<template>
  <div>
    <!--变更负责区域-->
    <el-dialog :visible.sync="updateAreaDialogVisible" title="变更负责区域" @close="feedBack" v-if="updateAreaDialogVisible">
      <el-form label-width="100px">
        <el-form-item label="原负责区域">
          <el-tag>{{originalAreaName === undefined ? "无": originalAreaName}}</el-tag>
        </el-form-item>
        <el-form-item label="新负责区域">
          <!--<el-select>-->
          <!--<el-option value="区域1" label="区域1"></el-option>-->
          <!--<el-option value="区域2" label="区域2"></el-option>-->
          <!--<el-option value="区域3" label="区域3"></el-option>-->
          <!--</el-select>-->
          <el-cascader v-model="UpdateAreaManager.params.newAreaId" :options="areaList.result.areaList" clearable
                       @click.native="getAreaList" style="width: 100%"></el-cascader>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="feedBack">取 消</el-button>
        <el-button type="primary" @click="updateAreaManager">确定修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'UpdateArea',
  props: ['updateAreaDialogVisible','originalAreaName', 'userId'],
  data(){
    return {
      // 获取区域列表
      GetAreaList:{
        "version": 1,
        "method": "area.GetAreaList",
        "params": null,
        "token": "",
        "id": 0
      },
      // 区域列表
      areaList:{
        "version": 1,
        "result":{
          "areaList": [
            {
              "areaId": "",
              "label": "",
              "childList":[],
            },
          ]
        },
        "id": 0
      },
      // 变更负责区域
      UpdateAreaManager:{
        "version": 1,
        "method": "user.UpdateAreaManager",
        "params": {
          "userId": "",
          "newAreaId": ""
        },
        "token": "",
        "id": 0
      }
    }
  },
  methods:{
    updateAreaManager(){
      this.UpdateAreaManager.token = this.$store.state.token;
      this.UpdateAreaManager.params.userId = this.userId;
      if(this.UpdateAreaManager.params.newAreaId !== null){
        this.UpdateAreaManager.params.newAreaId = this.UpdateAreaManager.params.newAreaId[this.UpdateAreaManager.params.newAreaId.length-1];
      }
      console.log('变更管理区域请求');
      console.log(this.UpdateAreaManager);
      this.$axios.post(this.$mainUrl, this.UpdateAreaManager).then(res =>{
        console.log('变更管理区域请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.$message({
            type:'success',
            message:'变更管理区域成功'
          })
          this.feedBack();
        }else{
          this.$message({
            type:'error',
            message:'变更管理区域失败，' + res.data.error.message
          })
        }
      })
    },
    // 获取区域列表
    getAreaList(){
      this.GetAreaList.token = this.$store.state.token;
      console.log('获取区域列表请求');
      console.log(this.GetAreaList);
      this.$axios.post(this.$mainUrl, this.GetAreaList).then(res=>{
        console.log('获取区域列表请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          let areaList = JSON.stringify(res.data);
          areaList  = areaList.replace(/childList/g, 'children');
          areaList  = areaList.replace(/areaName/g, 'label');
          areaList  = areaList.replace(/areaId/g, 'value');
          areaList = JSON.parse(areaList);
          console.log('areaList');
          console.log(areaList);
          this.areaList = areaList;
        }else{
          this.$message({
            type: 'error',
            message: '获取区域列表失败，' + res.data.error.message
          })
        }
      })
    },
    feedBack(){
      this.cleanArguments(this.UpdateAreaManager.params);
      this.updateAreaDialogVisible = false;
      this.$emit('feedBack',this.updateAreaDialogVisible);
    }
  }
}
</script>

<style scoped>

</style>
